const MUTATIONS = {
  SET_CURRENT_LISTE_ID: 'listes/setCurrentListeId'
}

export default {

    setListes (state, listes) {
      state.all = listes
    },

    setCurrentListeId (state, listeId) {
      state.currentListeId = listeId
    }
}

export { MUTATIONS as mutations }